module.exports = __webpack_public_path__ + "static/media/carrello.fa0b6378.svg";